module.exports = __webpack_public_path__ + "img/presentation-chart-03.6f46c97e.svg";